import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, User, Mail, Phone } from 'lucide-react';
export function Book() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    date: '',
    time: '',
    notes: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Booking submitted:', formData);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="w-full min-h-screen bg-white" data-id="element-77">
      {/* Hero Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50 text-zinc-950" data-id="element-78">
        <div className="max-w-4xl mx-auto text-center" data-id="element-79">
          <motion.p className="text-sm tracking-[0.3em] uppercase mb-8 text-zinc-600" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-80">
            Book Appointment
          </motion.p>
          <motion.h1 className="text-5xl md:text-7xl font-serif mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif'
        }} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-81">
            Book
          </motion.h1>
          <motion.p className="text-lg md:text-xl text-zinc-600 leading-relaxed max-w-2xl mx-auto" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-82">
            Schedule your consultation and take the first step toward optimal
            cellular health.
          </motion.p>
        </div>
      </section>

      {/* Booking Form */}
      <section className="px-6 py-32 md:py-40 bg-white" data-id="element-83">
        <div className="max-w-3xl mx-auto" data-id="element-84">
          <form onSubmit={handleSubmit} className="space-y-8" data-id="element-85">
            {/* Personal Information */}
            <div className="space-y-6" data-id="element-86">
              <h2 className="text-2xl font-serif mb-6 text-zinc-950" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-87">
                Personal Information
              </h2>

              <div data-id="element-88">
                <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-89">
                  Full Name *
                </label>
                <div className="relative" data-id="element-90">
                  <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-91" />
                  <input type="text" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full pl-12 pr-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" placeholder="Enter your full name" data-id="element-92" />
                </div>
              </div>

              <div data-id="element-93">
                <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-94">
                  Email Address *
                </label>
                <div className="relative" data-id="element-95">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-96" />
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full pl-12 pr-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" placeholder="your@email.com" data-id="element-97" />
                </div>
              </div>

              <div data-id="element-98">
                <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-99">
                  Phone Number *
                </label>
                <div className="relative" data-id="element-100">
                  <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-101" />
                  <input type="tel" required value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} className="w-full pl-12 pr-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" placeholder="(555) 123-4567" data-id="element-102" />
                </div>
              </div>
            </div>

            {/* Appointment Details */}
            <div className="space-y-6 pt-8 border-t border-zinc-200" data-id="element-103">
              <h2 className="text-2xl font-serif mb-6 text-zinc-950" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-104">
                Appointment Details
              </h2>

              <div data-id="element-105">
                <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-106">
                  Service *
                </label>
                <select required value={formData.service} onChange={e => setFormData({
                ...formData,
                service: e.target.value
              })} className="w-full px-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors bg-white" data-id="element-107">
                  <option value="" data-id="element-108">Select a service</option>
                  <option value="consultation" data-id="element-109">Initial Consultation</option>
                  <option value="nad-iv" data-id="element-110">NAD+ IV Therapy</option>
                  <option value="cellular" data-id="element-111">Cellular Optimization</option>
                  <option value="longevity" data-id="element-112">Longevity Protocol</option>
                  <option value="cognitive" data-id="element-113">Cognitive Enhancement</option>
                </select>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-114">
                <div data-id="element-115">
                  <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-116">
                    Preferred Date *
                  </label>
                  <div className="relative" data-id="element-117">
                    <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-118" />
                    <input type="date" required value={formData.date} onChange={e => setFormData({
                    ...formData,
                    date: e.target.value
                  })} className="w-full pl-12 pr-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" data-id="element-119" />
                  </div>
                </div>

                <div data-id="element-120">
                  <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-121">
                    Preferred Time *
                  </label>
                  <div className="relative" data-id="element-122">
                    <Clock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-123" />
                    <input type="time" required value={formData.time} onChange={e => setFormData({
                    ...formData,
                    time: e.target.value
                  })} className="w-full pl-12 pr-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" data-id="element-124" />
                  </div>
                </div>
              </div>

              <div data-id="element-125">
                <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-126">
                  Additional Notes
                </label>
                <textarea value={formData.notes} onChange={e => setFormData({
                ...formData,
                notes: e.target.value
              })} rows={4} className="w-full px-4 py-4 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors resize-none" placeholder="Any specific concerns or questions?" data-id="element-127" />
              </div>
            </div>

            <button type="submit" className="w-full px-12 py-4 bg-zinc-950 text-white text-sm tracking-[0.2em] uppercase font-medium hover:bg-zinc-800 transition-colors duration-300" data-id="element-128">
              Request Appointment
            </button>
          </form>
        </div>
      </section>
    </motion.div>;
}